module.exports = __webpack_public_path__ + "img/EUR.6027e168.png";